import {
  Tag, Dropdown, Menu, Radio, Button as AntdButton,
} from 'antd';
import {
  number, func, object, bool, string, arrayOf,
} from 'prop-types';

import { ChevronSVG } from 'components/iconsSVG/chevron';
import { CloseSVG } from 'components/iconsSVG/close';
import { useI18n } from 'context/i18n';
import {
  filterColors, FilterSVG, sorts,
} from 'utils/filters';
import { filterColors as searchFilterColors } from 'components/search/filterPanel';

import { FilterTag } from 'components/filterTag';
import styles from './style.module.css';

export function FilterHeader({
  open, toggle, count, filters, onRemoveFilter, hiddenFilters, onReset, total, onSort, currentSort,
}) {
  const { t } = useI18n();
  const hasFilters = filters && Object.keys(filters).length > 0;
  return (
    <div className={styles.filtersRow}>
      <div className={styles.filtersDivider} data-menu-open={open}></div>
      <div className={styles.panelLeft} data-menu-open={open}>
        <AntdButton
          className={`${styles.filterText} ${styles.filterHeaderBtn}`}
          size="small"
          type="text"
          onClick={toggle}
        >
          {open ? (
            <div>
              <CloseSVG/>  <span>{t('menu.lateral', 'cerrarfiltros', 'Close filters')}</span>
            </div>
          ) : (
            <div>
              <FilterSVG/>  <span>{t('menu.lateral', 'filtrar', 'Filter')} {count > 0 ? ` (${count})` : ''}</span>
            </div>
          )}
        </AntdButton>
      </div>
      <div className={styles.panelRight} >
        <div className={`${styles.appliedFilters}`}>
          {hasFilters ? (
            <>
              {Object.entries(filters).map(([ filterKey, filterValues ]) => {
                if (hiddenFilters.includes(filterKey)) return null;
                const filterObject = filterKey.includes('uFilter') ? searchFilterColors : filterColors;
                const colorLookupKey = filterKey.includes('uFilter') ? 'label' : 'key';
                return filterValues.map((appliedFilter) => (
                  <FilterTag
                    key={`${filterKey}.${appliedFilter.value}`}
                    onClick={() => onRemoveFilter(filterKey, appliedFilter)}
                    color={filterKey.includes('color') ? filterObject[appliedFilter[colorLookupKey]] : null}
                    label={appliedFilter.label !== '' ? appliedFilter.label : appliedFilter.urlParam}
                    checked={true}
                  />
                ));
              })}
              <Tag
                className={styles.resetTag}
                onClick={onReset}
              >
                {t('generico', 'boton.reiniciar', 'Reset')}
                <span className={styles.closeMarkSpan}><CloseSVG/></span>
              </Tag>
            </>
          ) : null}
        </div>
        <div className={styles.sortsDiv}>
          <p className={styles.productList}>
            {total} {t('listado.productos', 'articulos').toUpperCase()}
          </p>
          <div className={styles.dropdownWrapper}>
            <div className={styles.filterText}>
              {t('menu.lateral', 'ordenar.por')} :
            </div>
            <Dropdown
              overlay={
                <Menu>
                  {Object.keys(sorts).map((sortValue) => (
                    <Menu.Item key={sortValue}>
                      <Radio
                        onClick={() => onSort(sortValue)}
                        className={styles.sortRadio}
                        checked={currentSort === sortValue}>
                          {t('listado.productos', sorts[sortValue])}
                        </Radio>
                    </Menu.Item>
                  ))}
                </Menu>
              }
              overlayClassName={styles.sortsDropdown}
              placement="bottomCenter"
              trigger={[ 'click' ]}
            >
              <AntdButton
                size="small"
                type="text"
                className={`${styles.filterText} ${styles.filterHeaderBtn}`}
              >
                {t('listado.productos', sorts[currentSort])} <ChevronSVG className={styles.dropdownChevron} />
              </AntdButton>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  );
}

FilterHeader.propTypes = {
  open: bool.isRequired, // boolean to check if the filter panel is open
  toggle: func.isRequired, // function to toggle the filter panel
  count: number.isRequired, // number of filters active
  filters: object.isRequired, // object with the filters
  hiddenFilters: arrayOf(string), // array with the filters to hide
  onRemoveFilter: func.isRequired, // function to remove a filter
  onReset: func.isRequired, // function to reset all filters
  currentSort: string.isRequired, // current sort value
  onSort: func.isRequired, // function to sort the products
  total: number.isRequired, // number of products
};
